import { navImgAccess, navImgBeacon, navImgCamera, navImgIOT, navImgOS, navImgRTLS, navImgSensor, navImgWorld } from '@assets/images/nav';

export default {
  product: [
    {
      icon: navImgRTLS,
      title: 'ORBRO OS',
      link: '/cn/os',
      path: [
        { text: 'ORBRO 服务器', link: '/cn/os/server' },
        { text: 'ORBRO 边缘 RTLS', link: '/cn/os/rtls' },
        { text: 'ORBRO 边缘 AI', link: '/cn/os/ai' },
        { text: 'L2 交换机', link: '/cn/os/switch' },
      ],
    },
    {
      icon: navImgBeacon,
      title: '射频定位系统',
      link: '/cn/rtls',
      path: [
        { text: 'TwinTracker BLE', link: '/cn/rtls/ble' },
        { text: 'TwinTracker AoA', link: '/cn/rtls/aoa' },
        { text: 'TwinTracker UWB', link: '/cn/rtls/uwb' },
        { text: '舒适套件', link: '/cn/rtls/comfort' },
      ],
    },
    {
      icon: navImgAccess,
      title: '视频定位系统',
      link: '/cn/camera',
      path: [
        { text: 'AI 边缘设备', link: '/cn/camera/edge' },
        { text: 'AI 服务器', link: '/cn/camera/server' },
      ],
    },

    {
      icon: navImgAccess,
      title: '户外定位',
      link: 'none',
      path: [
        {
          text: 'GPS Device',
          link: '/cn/outdoor/gps',
        },
        {
          text: 'GPS Tag(LoRA)',
          link: '/cn/outdoor/lora',
        },
      ],
    },

    {
      icon: navImgSensor,
      title: '出入管理系统',
      link: '/cn/access',
      path: [
        { text: 'Access Auto', link: '/cn/access/auto' },
        { text: 'Access Lite', link: '/cn/access/pro' },
        { text: 'Access 配件', link: '/cn/access/accessory' },
      ],
    },
    {
      icon: navImgSensor,
      title: '工业物联网 (IIoT)',
      link: '/cn/iot',
      path: [
        { text: 'LoRA 传感器', link: '/cn/iot/LoRASensor' },
        { text: '二氧化碳检测仪', link: '/cn/iot/co2' },
        { text: '空气质量监测仪', link: '/cn/iot/air' },
        { text: '紧急呼叫铃', link: '/cn/iot/bell' },
      ],
    },
    // {
    //   icon: navImgWorld,
    //   title: '集成系统',
    //   link: '/cn/integration',
    //   path: [{ text: '机器人系统', link: '/cn/integration/robot' }],
    // },
  ],

  OS: {
    icon: navImgOS,
    title: 'ORBRO OS',
    desc: '从出入管理、实时定位到多种物联网控制，ORBRO 操作系统是将打造智能空间的所有方法集于一身的综合服务。现在就体验智能未来。',
    more: '了解更多',
    link: '/cn/os',
  },
  solution: [
    {
      title: '建筑',
      path: [
        {
          text: '工人安全管理',
          link: '/enterprise/construction/safety',
        },
        {
          text: '数字化SOP管理',
          link: '/enterprise/construction/sop',
        },
        {
          text: '起重机安全管理',
          link: '/enterprise/construction/equipment',
        },
      ],
    },
    {
      title: '智慧城市',
      path: [
        {
          text: '城市灾害数字孪生',
          link: '/enterprise/city/digitaltwin',
        },
        {
          text: '城市基础设施数字孪生',
          link: '/digital-twin',
        },
        {
          text: '停车场车辆定位追踪',
          link: '/enterprise/city/traffic',
        },
      ],
    },
    {
      title: '零售',
      path: [
        {
          text: '智能手机展示安全管理',
          link: '/enterprise/retail/mobile',
        },
        {
          text: '展馆访客分析',
          link: '/enterprise/retail/exhibition',
        },
        {
          text: '办公室资产管理',
          link: '/enterprise/retail/office',
        },
      ],
    },
    {
      title: '公共机构',
      path: [
        {
          text: '消防演练定位系统',
          link: '/enterprise/public/training',
        },
        {
          text: '十字路口行人安全方案',
          link: '/enterprise/public/crosswalk',
        },
        {
          text: '城市紧急呼叫系统',
          link: '/enterprise/public/safety',
        },
      ],
    },
    {
      title: '制造业',
      path: [
        {
          text: '钢铁物流自动化管理',
          link: '/enterprise/manufacturing/steel',
        },
        {
          text: '叉车位置追踪',
          link: '/enterprise/manufacturing/forklift',
        },
        {
          text: '制造流程实时管理',
          link: '/enterprise/manufacturing/process',
        },
      ],
    },
    {
      title: '物流',
      path: [
        {
          text: '仓库资产定位追踪',
          link: '/enterprise/logistics/asset',
        },
        {
          text: '集装箱定位追踪',
          link: '/enterprise/logistics/manage',
        },
      ],
    },
    {
      title: '医疗',
      path: [
        {
          text: '医疗废弃物机器人管理',
          link: '/enterprise/medical/waste',
        },
        {
          text: '患者及医疗设备定位追踪',
          link: '/enterprise/medical/patient',
        },
      ],
    },
    {
      title: '学校',
      path: [
        {
          text: '校园内风险行为自动检测',
          link: '/enterprise/education/safety',
        },
      ],
    },
  ],

  world: {
    icon: navImgWorld,
    title: 'ORBRO 数字孪生',
    desc: '接收现实世界中人、物、建筑和城市的数据，在数字虚拟环境中实时进行监控和管理。此技术可提升生产效率并预防问题，主要应用于工业和制造领域。',
    more: '了解更多',
    link: '/cn/digital-twin',
  },

  support: [
    {
      title: '客户支持',
      path: [
        { text: '公司介绍', link: '/cn/company' },
        { text: '销售咨询', link: '/cn/request' },
        { text: '经销商咨询', link: '/cn/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: '技术介绍',
      path: [
        { text: 'UWB 超宽带', link: '/cn/enterprise/technology/uwb' },
        { text: 'BLE 蓝牙', link: '/cn/enterprise/technology/ble' },
        { text: '立体视觉', link: '/cn/enterprise/technology/stereo-vision' },
        { text: '单目视觉', link: '/cn/enterprise/technology/monocular-vision' },
        { text: 'TDoA 到达时间差', link: '/cn/enterprise/technology/tdoa' },
        { text: 'TWR 往返时间', link: '/cn/enterprise/technology/twr' },
        { text: '地理围栏', link: '/cn/enterprise/technology/what-is-geofence' },
        { text: '数字孪生', link: '/cn/enterprise/technology/what-is-digital-twin' },
      ],
    },
    {
      title: '软件',
      link: 'new',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: '更新日志', link: '/release-note' },
      ],
    },
    {
      title: '社交媒体',
      link: 'new',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver 博客', link: 'https://blog.naver.com/orbro_platform' },
        { text: 'Medium', link: 'https://medium.com/@orbro' },
      ],
    },
  ],

  footerSupport: [
    {
      title: '支持',
      path: [
        { text: '博客', link: '/cn/blog' },
        { text: '销售咨询', link: '/cn/request' },
        { text: '报价请求', link: '/cn/pricing/1' },
        { text: '经销商咨询', link: '/cn/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: '下载',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: '更新日志', link: '/release-note' },
      ],
    },
    {
      title: '社交媒体',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver 博客', link: 'https://blog.naver.com/orbro_platform' },
      ],
    },
  ],
};
